import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import * as Table from 'reactabular-table';
import * as edit from 'react-edit';
import { map, cloneDeep, isEmpty, isEqual } from 'lodash';
import TwoElementsCell from './TwoElementsCell';
import RangeInput from './RangeInput';
import PriceInput from './PriceInput';
import Validate from './Validate';
import Headers from './SurchargeTableHeader';


class AccessorialRatesVehicleBaseEditor extends React.Component {
    static propTypes = {
        accessorialRate: PropTypes.object,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        const formatters = {
            fixedFloat: value => parseFloat(value).toFixed(2),
        };
        const validators = {
            type: value => Validate(value => (!isEmpty(value) && !isEqual(value, 'NaN')))(value || 'NaN'),
            rates: value => Validate(value => (value > 0))(value),
        };

        this.state = {
            accessorialRate: {},
            formatters: formatters,
            data: {},
            editedCell: null,
            editedKey: null,
            validators: validators,
        };
    }

    componentDidMount() {
        const accessorialRate = this.props.accessorialRate;
        if (accessorialRate) {
            const data = accessorialRate.vehicle_rates;
            this.setState({ data: data });
        }
    };

    onChangeData = (changedProperty) => {
        if (this.props.onChange) {
            this.props.onChange(changedProperty);
        }
    };

    createRow = (index) => {
        const dataRows = this.state.data || [];
        let newRow = {};
        if (dataRows.length && index > 0 && index <= dataRows.length) {
            const lastRow = dataRows[index - 1];
            newRow = JSON.parse(JSON.stringify(lastRow));
        } else {
            newRow = {
                type: '',
                rate: 0,
            };
        }
        return newRow;
    };

    addRow = () => {
        const data = this.state.data;
        const index = data.length;
        const newRow = this.createRow(index);
        data.push(newRow);
        this.setState({ data: data });
        this.onChangeData(data);
    };

    insertRow = (index) => {
        const data = this.state.data;
        const newRow = this.createRow(index);
        if (data.length && index <= data.length) {
            data.splice(index, 0, newRow);
            this.setState({ data: data });
            this.onChangeData(data);
        }
    };

    removeRow = (index) => {
        const data = this.state.data;
        if (data.length && index < data.length) {
            data.splice(index, 1);
            this.setState({ data: data });
            this.onChangeData(data);
        }
    };

    tableData = () => {
        const data = this.state.data;
        const tableData = map(data, function (item) {
            const row = {
                type: item.type,
                rate: item.rate,
                editing: item.editing,
            };
            return row;
        });
        return tableData;
    };

    tableColumns = () => {
        const formatters = (this.state) ? this.state.formatters : {};
        const data = this.state.data;
        const validators = this.state.validators;
        const columns = [];

        const context = this;
        const dataEditable = edit.edit({
            isEditing: ({ columnIndex, rowData }) => columnIndex === rowData.editing,
            onActivate: ({ columnIndex, rowIndex }) => {
                const dataClone = cloneDeep(this.state.data);
                dataClone[rowIndex].editing = columnIndex;
                this.setState({ data: dataClone });
            },
            onValue: ({ value, rowIndex, property }) => {
                const dataClone = cloneDeep(this.state.data);
                const row = dataClone[rowIndex];
                row[property] = value;
                row.editing = false;
                context.setState({ data: dataClone, editedKey: null });
                this.onChangeData(dataClone);
            },
        });
        columns.push({
            property: 'type',
            header: {
                label: 'Type',
            },
            cell: {
                formatters: [
                    validators.type,
                ],
                transforms: [
                    dataEditable(edit.input()),
                ],
            },
        });

        columns.push({
            property: 'rate',
            header: {
                label: 'Rate',
            },
            cell: {
                formatters: [
                    formatters.fixedFloat,
                    validators.rates,
                ],
                transforms: [
                    dataEditable(PriceInput()),
                ],
            },
        });

        columns.push({
            header: {
                label: (<div>Operation</div>),
            },
            cell: {
                formatters: [
                    (value, { rowIndex }) => {
                        const remove = () => {
                            this.removeRow(rowIndex);
                        };
                        const insert = () => {
                            const nextIndex = rowIndex + 1;
                            this.insertRow(nextIndex);
                        };

                        return (
                          <div>
                            <ButtonGroup bsSize="xsmall">
                              <Button
                                className="btn btn-success"
                                onClick={insert}
                              >&#10010;
                                        </Button>
                              <Button
                                className="btn btn-danger"
                                onClick={remove}
                              >&#10006;
                                        </Button>
                            </ButtonGroup>
                          </div>
                        );
                    },
                ],
            },
        });

        return columns;
    };

    render() {
        const columns = this.tableColumns();
        const tableData = this.tableData();
        return (
          <Table.Provider
            className="default-table"
            columns={columns}
          >
            <Table.Header />
            <Table.Body rows={tableData} rowKey={({ rowIndex }) => `${rowIndex}price-table`} />
            <tfoot>
              <tr>
                {columns.map((column, i) => {
                    if (i === 0) {
                        return (<td key={`${i}-footer`}>
                          <Button
                            bsSize="xsmall"
                            className="btn btn-default"
                            onClick={this.addRow}
                          >Add Row
                                                </Button>
                        </td>);
                    }
                    return (<td key={`${i}-footer`} />);
                })}
              </tr>
            </tfoot>
          </Table.Provider >
        );
    }
}

export default AccessorialRatesVehicleBaseEditor;
